import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';

import CircleIcon from './icons/circle_icon';

export default class HoldButton extends React.Component {
  constructor(props) {
    super(props);
    this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
  }
  render() {
    return (
      <CircleIcon viewBox="0 0 25 25" {...this.props}>
        <g id="iconHold">
          <path d="M13.687 17.348h2.674v-9.82h-2.673M9 17.348h2.674v-9.82H9" />
        </g>
      </CircleIcon>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/phone_controls/buttons/hold_button.jsx